import * as ContextApi from '@bmai/context-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new ContextApi.Configuration(ApiClientFactory.createConfig('/_context'));

export const contextClient = ApiClientFactory.instantiateApis(ContextApi, configuration);
